<template>
    <header class="site-header">
    <PrimaryNav class="primary-nav" :links="navLinks" siteColour />
    <span v-if="hasTranslations" class="divider">|</span>
    <TranslationNav class="primary-nav" :links="translationLinks" siteColour />
    <Translate />
  </header>
</template>

<script>
import PrimaryNav from "@/components/PrimaryNav.vue";
import Translate from "@/components/Translate.vue";
import TranslationNav from "@/components/TranslationNav.vue";

export default {
  name: "site-header",
  props: {
    navLinks: Array,
    translationLinks: Array,
    siteColour: String,
  },
  components: {
    PrimaryNav,
    Translate,
    TranslationNav
  },
  methods: {
    hasTranslations() {
      return this.props.translationLinks.length > 0;
    }
  }
}
</script>

<style lang="scss" scoped>
  .site-header {
    position: fixed;
    top: 0;
    right: 0;
    display: flex;
    flex-flow: row nowrap;
    justify-content: flex-end;
    align-items: center;
    margin-top: 0;
    height: 3em;
    padding: 0 1em 0 1em;
    border-radius: 0 0 0 5px;
    z-index: 500;

    @media screen and (max-width: $break-container) {
      right: $container-padding;
    }

    @media screen and (max-width: $break-mobile) {
      position: absolute;
      top: 0;
      right: 1em;
      background: transparent;

      .primary-nav {
        display: none;
      }

      .primary-nav.translation-nav {
        background-color: var(--white);
        display: block;
      }
    }


    span.divider {
      margin-right: 1em;

      @media screen and (max-width: $break-mobile) {
        display: none;
      }
    }
  }

  [dir="rtl"] span.divider {
    margin-right: 0;
  }

  .has-translations .site-header {
    @media screen and (max-width: $break-mobile) {
      flex-flow: wrap;
    }
    @media screen and (max-width: 1200px) {
      right: 0;
    }
  }
</style>
